<!--
* @description 底部组件
* @fileName Footer.vue
* @author liulian
* @date 2023/06/30 09:15:05
-->
<template>
  <div class="footer-dark">
    <div class="footer_container">
      <header class="top flex-row">
        <div class="f_right">
          <div class="logo-box">
            <img class="logo" src="@/assets/images/dnn_logo.png" alt="" />
          </div>
          <div class="r_list flex-row-between">
            <div class="l_item" v-for="(item, index) in lists" :key="index">
              <div class="i_title font-size-18 font-weight-600">
                {{ item.title }}
              </div>
              <div class="i_ls foot-downLoad">
                <template v-for="(i, indexItem) in item.children">
                  <div
                    :key="indexItem"
                    class="i_con font-size-14 font-weight-400"
                    :class="{ isCursor: !!i.url }"
                    @click="openUrl(item.title, i.url)"
                  >
                    {{ i.title }}
                  </div>
                </template>
              </div>
            </div>
            <div class="l_item">
              <div class="i_title font-size-18 font-weight-600">公众号</div>
              <img src="@/assets/images/gzh_ewm.svg" class="ewm" alt="" />
            </div>
          </div>
        </div>
      </header>
      <footer class="copyright font-size-14 font-weight-400">
        <p class="t_p text-align-center">
          版权所有@2018 江苏狄诺尼信息技术有限责任公司
        </p>
        <p class="t_p text-align-center">苏ICP备18062906号</p>
      </footer>
    </div>
  </div>
</template>

<script>
import DownLoad from "@/components/DownLoad";
export default {
  name: "Footer",
  components: { DownLoad },
  data() {
    return {
      lists: [
        {
          title: "核心产品",
          children: [
            {
              title: "数字设计软件产品",
              url: "/digital",
            },
            {
              title: "智能建造产品",
              url: "/intelligent",
            },
            {
              title: "数字运维产品",
              url: "/dtwin",
            },
          ],
        },
        {
          title: "狄诺尼学院",
          children: [
            {
              title: "帮助文档",
              url: "/download?anchor=manual",
            },
            {
              title: "软件教学",
              url: "/academy",
            },
          ],
        },
        {
          title: "下载中心",
          children: [
            {
              title: "软件下载",
              url: "/download?anchor=software",
            },
            {
              title: "手册下载",
              url: "/download?anchor=manual",
            },
          ],
        },
        {
          title: "客户服务与咨询",
          children: [
            {
              title: "客户服务：4000-025-828",
            },
            {
              title: "设计软件咨询：吴经理  17730442539",
            },
            {
              title: "智能建造咨询：董经理  15280106801",
            },
            {
              title: "国际业务咨询：张经理  15852479508",
            },
          ],
        },
        {
          title: "地址",
          children: [
            {
              title: "江苏省南京市江宁区智识路26号",
            },
            {
              title: "启迪科技城立业园1幢7楼",
            },
          ],
        },
      ],
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    openUrl(type, url) {
      if (url) {
        this.$uniFun.openInCurrentTab(`${url}`);
      }
    },
  },
};
</script>

<style lang="scss">
.footer-dark {
  width: 100%;
  background: #242424;
  .footer_container {
    width: 1200px;
    margin: 0 auto;
    padding: 45px 0;
    color: #fff;

    .top {
      width: 100%;
      margin: auto;
    }

    .f_right {
      flex: 1;
      .logo-box {
        width: 100%;
        padding-bottom: 24px;
        margin-bottom: 24px;
        border-bottom: 1px solid #d8d8d8;
        .logo {
          width: 200px;
          height: auto;
        }
      }
      .r_list {
        width: 100%;
      }
      .title {
        padding-bottom: 24px;
        border-bottom: 1px solid #d8d8d8;
        margin-bottom: 24px;
      }
      .l_item {
        max-width: 275px;
        .i_title {
          margin-bottom: 24px;
        }
        .width210 {
          width: 210px;
        }
        .i_con {
          color: rgba(255, 255, 255, 0.6);
          margin-bottom: 16px;
          &.isCursor {
            cursor: pointer;
            &:hover {
              color: #0035fb;
              text-decoration: underline;
            }
          }
        }
        .i_con:last-child {
          margin-bottom: unset;
        }
        .l_img {
          width: 120px;
          height: 120px;
        }
        .ewm {
          width: 120px;
          height: auto;
        }
      }
      .l_item:last-child {
        margin-right: unset;
      }
    }
    .copyright {
      color: rgba(255, 255, 255, 0.6);
      margin-top: 24px;
      .t_p:first-child {
        margin-bottom: 12px;
      }
      .i_ls {
        font-family: PingFang SC-Regular, PingFang SC;
      }
    }
    .foot-downLoad .dnn-download-box {
      display: block;
    }
  }
}
</style>
